import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { TextStylesTable } from '../components';
import { TextStyleItem } from '../types';

export const TextStylesPage: FC = () => {
  const navigate = useNavigate();

  const redirectToTextStyleDetails = (item: TextStyleItem) => {
    navigate(Routes.TextStyleDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Text Styles"
        actions={[
          <Link
            to={Routes.NewTextStyle}
            key="new-text-style"
            data-testid="add-new-text-style-link"
          >
            <Button data-testid="add-new-text-style-button">
              <PlusSquareIcon />
              Add new text style
            </Button>
          </Link>,
        ]}
      />

      <TextStylesTable onClick={redirectToTextStyleDetails} />
    </div>
  );
};
